import Vue from 'vue'
import Router from 'vue-router'

import { store } from '../main.js'

import Home from './home'
import Login from './login'
import User from './user'
import Profile from './profile'
import Check from './check'
import MyChecks from './myChecks'
import TeamChecks from './teamChecks'
import AditionalHour from './aditionalHour'
import ManualCheck from './manualCheck'
import Holidays from './holidays'
import CheckRequest from './checkRequest'
import Worktime from './worktime'
import PointMirror from './pointMirror'
import Vacation from './vacations'
import AbsenceRequest from './absenceRequest'
import Departments from './departments'
import Roles from './roles'
import Configuration from './configuration'
import TransportationRequest from './transportationRequest'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    linkActiveClass: "active",
    hashbang: false,
    routes: [
        Login,
        Home,
        User,
        Profile,
        Check,
        MyChecks,
        TeamChecks,
        AditionalHour,
        ManualCheck,
        Holidays,
        CheckRequest,
        Worktime,
        PointMirror,
        AbsenceRequest,
        Departments,
        Roles,
        Vacation,
        Configuration,
        TransportationRequest
    ]
});

router.beforeEach((to, from, next) => {
    const authenticated = localStorage.getItem('token');

    if (!authenticated && to.path.toString() != '/login') {
        next('/login');

        return true;
    }

    if (authenticated && to.path.toString() == '/login') {
        next('/');

        return true;
    }

    if (["/users", "/teamChecks", "/check", "/point-mirror"].includes(to.path.toString())) {
        console.log(localStorage.getItem("is_admin"));

        if (localStorage.getItem("is_admin") === '1') {
            next();
            return true;
        } else {
            next('/');
            return true;
        }
    }
    next();
});

router.afterEach((to, from) => {
    let _name = to.name;
    let _route = to.fullPath;

    if (_name === 'Home') {
        _name = '';
        _route = '';
    }

    store.commit("updateBreadCrumbs", { name: _name, route: _route })
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js